var _path, _path2, _path3, _path4, _path5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExploitsLight = function SvgExploitsLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 76,
    fill: "none",
    viewBox: "0 0 78 76"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 63.299,
    x: 16,
    y: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#exploits-light_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#exploits-light_svg__b)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits-light_svg__c)",
    fillOpacity: 0.2,
    d: "M26.594 24.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.848-2.99c.938-.957 2.222-1.6 4.79-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits-light_svg__d)",
    d: "M26.594 24.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.848-2.99c.938-.957 2.222-1.6 4.79-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeOpacity: 0.05,
    d: "M45.211 8.574a7.5 7.5 0 0 1 2.766 0c1.015.19 1.993.674 4.118 1.737l7.2 3.6c2.6 1.3 3.792 1.902 4.657 2.786a7.5 7.5 0 0 1 1.732 2.803c.403 1.17.41 2.504.41 5.412v8.178c0 2.908-.007 4.243-.41 5.412a7.5 7.5 0 0 1-1.732 2.803c-.865.883-2.056 1.486-4.657 2.787l-7.2 3.6c-2.125 1.062-3.103 1.545-4.118 1.736a7.5 7.5 0 0 1-2.766 0c-1.016-.19-1.993-.674-4.118-1.736l-7.2-3.6c-2.601-1.3-3.792-1.904-4.658-2.787a7.5 7.5 0 0 1-1.731-2.803c-.403-1.17-.41-2.504-.41-5.412v-8.178c0-2.908.007-4.242.41-5.412a7.5 7.5 0 0 1 1.731-2.803c.866-.883 2.057-1.486 4.658-2.787l7.2-3.6c2.125-1.062 3.102-1.545 4.118-1.736Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 63.299,
    x: 8,
    y: 6
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#exploits-light_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#exploits-light_svg__f)",
    shapeRendering: "crispEdges"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits-light_svg__g)",
    fillOpacity: 0.5,
    d: "M18.594 30.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.957 2.223-1.6 4.791-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits-light_svg__h)",
    fillOpacity: 0.25,
    d: "M18.594 30.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.957 2.223-1.6 4.791-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M37.21 14.574a7.5 7.5 0 0 1 2.767 0c1.015.19 1.993.674 4.118 1.737l7.2 3.6c2.6 1.3 3.791 1.902 4.657 2.786a7.5 7.5 0 0 1 1.732 2.803c.403 1.17.41 2.504.41 5.412v8.178c0 2.908-.007 4.243-.41 5.412a7.5 7.5 0 0 1-1.732 2.803c-.865.883-2.056 1.486-4.657 2.787l-7.2 3.6c-2.125 1.062-3.103 1.545-4.118 1.736a7.5 7.5 0 0 1-2.766 0c-1.016-.19-1.993-.674-4.118-1.736l-7.2-3.6c-2.601-1.3-3.792-1.904-4.658-2.787a7.5 7.5 0 0 1-1.731-2.803c-.403-1.17-.41-2.504-.41-5.412v-8.178c0-2.908.007-4.242.41-5.412a7.5 7.5 0 0 1 1.731-2.803c.866-.883 2.057-1.486 4.658-2.787l7.2-3.6c2.125-1.062 3.102-1.545 4.118-1.736Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 63.299,
    x: 0,
    y: 12
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#exploits-light_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#exploits-light_svg__j)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits-light_svg__k)",
    d: "M10.594 36.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.957 2.223-1.6 4.791-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M29.21 20.574a7.5 7.5 0 0 1 2.767 0c1.015.19 1.993.674 4.118 1.737l7.2 3.6c2.6 1.3 3.791 1.902 4.657 2.786a7.5 7.5 0 0 1 1.732 2.803c.403 1.17.41 2.504.41 5.412v8.178c0 2.908-.007 4.243-.41 5.412a7.5 7.5 0 0 1-1.732 2.803c-.865.883-2.056 1.486-4.657 2.787l-7.2 3.6c-2.125 1.062-3.103 1.545-4.118 1.736a7.5 7.5 0 0 1-2.766 0c-1.016-.19-1.993-.674-4.118-1.736l-7.2-3.6c-2.601-1.3-3.792-1.904-4.658-2.787a7.5 7.5 0 0 1-1.731-2.803c-.403-1.17-.41-2.504-.41-5.412v-8.178c0-2.908.007-4.242.41-5.412a7.5 7.5 0 0 1 1.731-2.803c.866-.883 2.057-1.486 4.658-2.787l7.2-3.6c2.125-1.062 3.102-1.545 4.118-1.736Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exploits-light_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29.594 32.001v12"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exploits-light_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29.594 48.001v1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "exploits-light_svg__b",
    width: 61.188,
    height: 63.299,
    x: 16,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits-light_svg__f",
    width: 61.188,
    height: 63.299,
    x: 8,
    y: 6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits-light_svg__j",
    width: 61.188,
    height: 63.299,
    x: 0,
    y: 12,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits-light_svg__l",
    width: 4,
    height: 16,
    x: 27.594,
    y: 31.001,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26739"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26739",
    result: "effect2_dropShadow_2555_26739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits-light_svg__m",
    width: 4,
    height: 5,
    x: 27.594,
    y: 47.001,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26739"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26739",
    result: "effect2_dropShadow_2555_26739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exploits-light_svg__c",
    x1: 46.594,
    x2: 46.594,
    y1: 26.526,
    y2: 51.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exploits-light_svg__g",
    x1: 38.594,
    x2: 38.594,
    y1: 32.526,
    y2: 57.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exploits-light_svg__k",
    x1: 31.898,
    x2: 31.898,
    y1: 19.589,
    y2: 85.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "exploits-light_svg__a",
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.594 24.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.848-2.99c.938-.957 2.222-1.6 4.79-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "exploits-light_svg__e",
    transform: "translate(-8 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.594 30.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.957 2.223-1.6 4.791-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "exploits-light_svg__i",
    transform: "translate(0 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.594 36.912c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.957 2.223-1.6 4.791-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989c.437 1.267.437 2.703.437 5.575v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.15 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "exploits-light_svg__d",
    width: 1.6,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#exploits-light_svg__n",
    transform: "scale(.00156 .00142)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "exploits-light_svg__h",
    width: 1.6,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#exploits-light_svg__n",
    transform: "scale(.00156 .00142)"
  })))));
};
export default SvgExploitsLight;